import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { AudioRecordingState, recordingStateAtom } from '../../video-sdk';
import { useSendVisitorParticipantStateCallback } from '../messages/useSendVisitorParticipantState';

export function useToggleRecordingCallback() {
  const getRecordingState = useAtomCallbackMemoized((get) => get(recordingStateAtom), []);
  const setRecordingState = useSetAtom(recordingStateAtom);
  const sendParticipantState = useSendVisitorParticipantStateCallback();

  return useCallback(
    (shouldRecord?: boolean) => {
      if (getRecordingState().value === AudioRecordingState.DISABLED) return;

      if (shouldRecord === undefined) {
        // Toggle whatever the current state is.
        shouldRecord = getRecordingState().value === AudioRecordingState.NOT_RECORDING;
      }
      const newRecordingState = shouldRecord ? AudioRecordingState.RECORDING : AudioRecordingState.NOT_RECORDING;

      setRecordingState({
        value: newRecordingState,
        lastUpdated: Date.now(),
      });
      sendParticipantState();
    },
    [getRecordingState, sendParticipantState, setRecordingState],
  );
}
